//import mtl from 'mtl-js-sdk';
import {
    get,
    post,
    newPost
} from 'server/api';
//const mtl = window.mtl || {};

export const getAllMaterial = param => {
    let url = '/service/sendCar';
    return new Promise((resolve, reject) => {
        post(url, param).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        })
    }).catch(error => {
        console.log(error);
    })
};

export const getMaterialDetail = param => {
    let url = '/service/sendCar';
    return new Promise((resolve, reject) => {
        post( url, param ).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        })
    }).catch(error => {
        console.log(error);
    })
}

export const changeStatus = param => {
    let url = "/service/sendCar";
    return new Promise((resolve, reject) => {
        post( url, param ).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        })
    }).catch(error => {
        console.log(error);
    })
}

export const openAdmission = param => {
    let url = "/service/sendCar";
    return new Promise((resolve, reject) => {
        post( url, param ).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        })
    }).catch(error => {
        console.log(error);
    })
}

export const checkPound = param => {
    let url = "/service/sendCar";
    return new Promise((resolve, reject) => {
        post( url, param ).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        })
    }).catch(error => {
        console.log(error);
    })
}

export const getDeliveryFiles = param => {
    let url = "/service/getDeliveryFilesServlet";
    return new Promise((resolve, reject) => {
        newPost( url, param ).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        })
    }).catch(error => {
        console.log(error);
    })
}
